module.exports = __webpack_public_path__ + "355ba2b70cd5f1deb92d9eeb54eb2a60.jpg";